module.exports = __webpack_public_path__ + "static/joinIllustration-84ee4e8d3ad49b262f0e05d4cecf2e8f.svg";